var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15H1V1h6.5a.5.5 0 0 0 0-.999h-7a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.855 7.65-3.45-3.499a.496.496 0 0 0-.707 0 .508.508 0 0 0 0 .714l2.6 2.638H4.002c-.276 0-.5.226-.5.505s.224.505.5.505h10.296l-2.6 2.637a.508.508 0 0 0 0 .714.496.496 0 0 0 .707 0l3.45-3.5a.511.511 0 0 0 0-.713Z",
    fill: "#000"
  })));
};
export default SvgSignOut;